import { State } from './State';
import { LayoutColumn } from './LayoutColumn';
import { Sorting } from './Sorting';

export class LayoutData {
  public state: State;
  public columns: LayoutColumn[];

  constructor(
    state: State = new State([new Sorting('')]),
    columns: LayoutColumn[] = new Array<LayoutColumn>()
  ) {
    this.state = state;
    this.columns = columns;
  }
}
